import { makeSelectedLogicByFinancialProduct } from '../../logic/selected/make';
import { STypeGrp } from '../../../../types';
export * from '../../../financialProducts/fields/STOCK/logic';
export function makeSelectedLogic(props) {
    var alternatives = props.alternatives;
    return makeSelectedLogicByFinancialProduct({
        financialProduct: STypeGrp.ACTIONS,
        alternatives: alternatives,
    });
}
